/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import { Link } from 'react-router-dom';
// eslint-disable-next-line
const AddSection = (props) => {
	const {adsData, commonLangugaeContent} = props;
	return (
		<>
			{adsData &&
				adsData.length > 0 &&
				// eslint-disable-next-line
				adsData.map((item, i) => (
					<div className='portfolio-details mt-5 mb-5' key={item?.id}>
						<Link to={`/event-details/${item?.section}/${item?.details}`} className='btn-link'>
							<div className='container'>
								<div className='row align-items-top'>
									<div className='col-lg-12'>
										<div className='ads'>
											<div className='row'>
												<div className='col-sm-3'>
													<div className='project-wrap hover-container'>
														<div className='project-video-wrap'>
															{item.image ? (
																<img
																	src={'../../assets/img/pages/' + item?.image + '.webp'}
																	alt={item?.image}
																	className='project-video '
																/>
															) : (
																<img src={general?.dark_logo} alt={general?.dark_logo} className='project-video ' />
															)}
														</div>
													</div>
												</div>
												<div className='col-sm-9'>
													<div className='project-dec'>
														<h5 style={{ color: '#' + commonLangugaeContent['AAANXC'] }}>
															{commonLangugaeContent['AAANXT'] ? commonLangugaeContent['AAANXT'] : ''}
														</h5>
														<p>{item?.title}</p>
														<p>
															<span dangerouslySetInnerHTML={{ __html: item?.text }}></span>
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Link>
					</div>
				))}
		</>
	);
};

export default AddSection;
